<script>
export default {
  props: {
    autocompleteList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    querySearch (queryString, cb) {
      var autocompleteList = this.autocompleteList.map(x => { return { value: x, link: x } })
      var results = queryString
        ? autocompleteList.filter(this.createFilter(queryString))
        : autocompleteList
      cb(results)
    },
    createFilter (queryString) {
      return (item) => {
        return (
          item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    }
  }
}
</script>
